/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-04-28 09:57:30
 */
 import * as Vue from 'vue-tsx-support';
 import { Component } from 'vue-property-decorator';
 import './roleDataConfig.less';
 import { createBEM, createNamespace } from 'src/util/bem';
 import FrameSideBg from 'src/pages/layout/components/frameSideBg';
 import SysSideList from './components/sysSideList';
 import FrameContentBg from 'src/pages/layout/components/frameContentBg';
 import roleDataConfigApi from './api/roleDataConfigApi';
 import { Integer } from 'src/types/base';
 import { Toast } from 'src/util/toast';
 import EnumOperates from 'src/enums/enumOperates';
 import { CommonUtil } from 'src/util/commonUtil';
 import Button from 'src/types/iview/Button';
 import EnumAuthorityType from 'src/enums/enumAuthorityType';
 import { MenuI } from 'src/pages/store/modules/layout';
 let bem = createBEM('role-data-config');

 @Component({ name: 'role-data-config' })
export default class RoleDataConfig extends Vue.Component<any> {
    roles: { id: number; name: string }[] = [];
    currentRole: Integer = null;
    data: any = [];
    sourceData: any = [];
    loading: boolean = false;
    authorityMenusMap: any = {};
    async mounted() {
        await this.queryAllRoles();
        await this.queryAllMenu();
        this.selectFirst();
    }
    async queryAllMenu() {
        let { code, data } = await roleDataConfigApi.queryCategories();
        if (code === 0) {
            data.forEach(i => {
                i["title"] = i.data_name;
            });
            this.sourceData = [
                {
                    title: '资料类别',
                    expand: true,
                    children: data
                },
            ];
            this.data = JSON.parse(JSON.stringify(this.sourceData));
        }
    }

    async setMenu() {
        var menu = null;
        let {code, data } = await roleDataConfigApi.queryCategories();
        menu = data;
        if (this.currentRole) {
            let { code, data } = await roleDataConfigApi.queryAuthorityByRol(this.currentRole);
            if (code === 0) {
                CommonUtil.treeForEach(menu, (i: any) => {
                    i["title"] = i.data_name;
                    let realMenu = data.find(sub => i.id === sub.data_categories_id);
                    if (!realMenu) {
                        return;
                    }
                    i.checked = data.some(sub => i.id === sub.data_categories_id);
                });
                this.sourceData = [
                    {
                        title: '资料类别',
                        expand: true,
                        children: menu
                    },
                ];
                this.data = JSON.parse(JSON.stringify(this.sourceData));;
            }
        }
    }

    async queryAllRoles() {
        let { code, data } = await roleDataConfigApi.searchList();
        if (code === 0) {
            this.roles = data.data_info.map(i => ({ id: i.id, name: i.role_name }));
        }
    }

    selectFirst() {
        if (this.roles[0]) {
            this.currentRole = this.roles[0].id;
            this.setMenu();
        }
    }

    async add(i) {
        let res = await alertRoleOperateModal(EnumOperates.Add.getName());
        if (res) {
            this.queryAllRoles();
        }
    }

    async update(i) {
        let res = await alertRoleOperateModal(EnumOperates.Update.getName(), i);
        if (res) {
            this.queryAllRoles();
        }
    }

    async delete(i: { id: number; name: string }) {
        if (await Toast.confirm()) {
            let { code } = await roleDataConfigApi.delete(i.id);
            if (code === 0) {
                Toast.success('删除成功！');
                await this.queryAllRoles();
                // 删除的是当前选中的角色
                if (this.currentRole === i.id) {
                    this.selectFirst();
                }
            }
        }
    }

    roleChange(id: number) {
        this.currentRole = id;
        this.setMenu();
    }

    async save() {
        if (!this.currentRole) {
            Toast.error('请选择角色！');
            return;
        }
        let ids: number[] = [];
        CommonUtil.treeForEach(this.data, (i: any) => {
            if ((!i.children || i.children.length === 0) && i.checked) {
                ids.push(i.id);
            }
        });
        this.loading = true;
        let { code } = await roleDataConfigApi.saveAuthority(this.currentRole, ids);
        if (code === 0) {
            Toast.success('保存成功');
        }
        this.loading = false;
    }

    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')}>
                    <FrameSideBg padding={false} style="height: 100%">
                        <SysSideList
                            value={this.currentRole}
                            on-input={this.roleChange.bind(this)}
                            dataSource={this.roles}
                            title="角色"
                            on-add={this.add.bind(this)}
                            on-update={this.update.bind(this)}
                            on-delete={this.delete.bind(this)}
                        />
                    </FrameSideBg>
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <div class={bem('right-menu-title')}>
                        用户资料配置
                        <Button type="primary" on-click={this.save.bind(this)}>
                            保存
                        </Button>
                    </div>
                    <FrameContentBg showCorner={false} radius={true}>
                        <div class={createNamespace('pa30')}>
                            <tree ref="tree" class={bem()} data={this.data} show-checkbox check-directly />
                        </div>
                    </FrameContentBg>
                </i-content>
            </layout>
        );
    }
}

